module.exports = __webpack_public_path__ + "img/connect.d0730ec6.png";